import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { resolveAssetUrl } from "@/lib/api";

const HIGHLIGHTS = [
  "Suporte técnico com SLA dedicado",
  "Equipe certificada Linux, Windows, Mikrotik e Cloud",
  "Desenvolvimento sob medida com tecnologias modernas",
  "Atendimento presencial e remoto",
];

export default function AboutSection() {
  const { content } = useSite();

  return (
    <section data-testid="about-section" className="section-padding bg-white relative">
      <div className="dc-container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="aspect-[4/5] rounded-3xl overflow-hidden relative">
              <img
                src={resolveAssetUrl(content.about_image_url, "https://images.unsplash.com/photo-1758873271805-1ff103e28558?crop=entropy&cs=srgb&fm=jpg&q=85&w=800")}
                alt="Equipe DeskcodeBR"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-dc-secondary/40 via-transparent to-transparent"></div>
            </div>

            <div className="absolute -bottom-8 -right-8 bg-white p-6 rounded-2xl shadow-2xl border border-slate-100 max-w-[260px] hidden md:block">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 rounded-full bg-dc-primary/10 flex items-center justify-center">
                  <CheckCircle2 className="w-5 h-5 text-dc-primary" />
                </div>
                <div className="font-heading font-bold text-3xl text-dc-text">{content.stat_years || "8+"}</div>
              </div>
              <div className="text-sm text-slate-600">Anos transformando empresas com tecnologia.</div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-dc-primary">Sobre a DeskcodeBR</span>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-dc-text mt-3 mb-5 leading-tight">
              Tecnologia que <span className="text-dc-primary">simplifica</span> e impulsiona seu negócio
            </h2>
            <p className="text-base md:text-lg text-slate-600 leading-relaxed mb-7">
              {content.about_text?.split(".")[0]}.
            </p>

            <ul className="space-y-3 mb-9">
              {HIGHLIGHTS.map((h, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-dc-primary/10 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <CheckCircle2 className="w-3.5 h-3.5 text-dc-primary" />
                  </div>
                  <span className="text-slate-700">{h}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-wrap gap-3">
              <Link to="/sobre" data-testid="about-cta-saiba-mais" className="inline-flex items-center gap-2 bg-dc-primary hover:bg-dc-primary-hover text-white px-7 py-3.5 rounded-full font-semibold transition-all shadow-lg shadow-dc-primary/20">
                Conheça a empresa <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/servicos" className="inline-flex items-center gap-2 border-2 border-slate-200 hover:border-dc-primary text-dc-text hover:text-dc-primary px-7 py-3.5 rounded-full font-semibold transition-all">
                Ver serviços
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
